import React from 'react';
import classnames from 'classnames';

import { Button } from '../../material-ui/Button';
import { useStyles } from '../useStyles';

const Shortcut = ({ shortcut, currentValue, clickHandler }) => {
    const classes = useStyles();
    const { label, value } = shortcut;
    const isCurrentValue = React.useMemo(() => currentValue === value.toString(), [value, currentValue]);

    return (
        <Button onMouseDown={clickHandler} value={value} className={classnames(classes.shortcut, classes.text)} disabled={isCurrentValue}>
            {label}
        </Button>
    );
};

export { Shortcut };
